import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container mt-60">
      <div className="loader"></div>
      <div className='loading_caption'>Loading...</div>
    </div>
  );
};

export default Loader;
